module.exports = __webpack_public_path__ + "static/img/ico_cos.d572f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010104/ico_cos.png
// module id = Zjfl
// module chunks = 10